import React from 'react';

const HighlightText = ({ text, search, matchRef }) => {
    if (!search || !text) return text || '';
    const lower = text.toLowerCase();
    const idx = lower.indexOf(search.toLowerCase());
    if (idx === -1) return text;
    return (
        <span ref={matchRef}>
            {text.slice(0, idx)}
            <mark className="djpal-highlight">{text.slice(idx, idx + search.length)}</mark>
            {text.slice(idx + search.length)}
        </span>
    );
};

export default HighlightText;
